export default __webpack_public_path__ + "static/media/IMG-20250105-WA0026.8787a234.jpg";